<div class="dropup-button-group">
    <button mat-flat-button [disabled]="isDisabled" class="{{iconClassName}}" ngClass="{{buttonClassName}}" *ngIf="!isLoading" (click)="buttonClickEvent($event)">
        {{buttonText}}
        <!-- <div [class]="iconClassName"></div> -->
    </button>
    <button mat-flat-button [disabled]="isDisabled" class="btn-innerico setting" *ngIf="isLoading" class="{{buttonClassName}}" [ngClass]="isLoading ?  'setting btn-loader' : ''" >
        <!-- <div class="btn-innerico setting"></div> -->
    </button>
    <button mat-icon-button [disabled]="isLoading || isDisabled" class="{{dropupClassName}}" [matMenuTriggerFor]="dropup">
        <!-- <mat-icon>expand_less</mat-icon> -->
        <itb-icon class="btn-icon angle-up tab-inner-ico icon-white"></itb-icon>
    </button>
</div>
<mat-menu #dropup="matMenu" yPosition="above">
    <button class="dropup-items" mat-menu-item *ngFor="let item of dropupItems" (click)="dropupClickEvent(item.label)">
        <itb-icon class="dropup-btns" [className]="item.className"></itb-icon>
        {{item.label}}
    </button>
</mat-menu>